import { useDispatch } from 'react-redux';

import { triggerLogout } from '@atom/actions/userActions';
import { Button } from '@atom/mui';

import AuthLogo from './AuthLogo';
import LoginFooter from './LoginFooter';

import classes from './login.module.css';

const Unverified = () => {
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(triggerLogout());
  };

  return (
    <div className={classes.container}>
      <div className={classes.authBackground} />
      <div className={classes.logoOffset}>
        <AuthLogo />
      </div>
      <div className={classes.innerContainer}>
        <div className={classes.contentContainer}>
          <div className={classes.unverifiedContent}>
            <div className={classes.unverifiedHeading}>
              Thank you for signing up for Atom!
            </div>
            <div className={classes.unverifiedContentDescription}>
              <p>
                You have successfully signed up for Atom. An administrator will
                review your profile and notify you when the account has been
                given access to the application.
              </p>
              <p>
                If you have any questions, please contact your administrator
                directly.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.navContainer}>
        <div className={classes.unverifiedLoginButton}>
          <Button
            style={{ color: 'black' }}
            color="inherit"
            variant="contained"
            onClick={logout}
          >
            BACK TO LOGIN
          </Button>
        </div>
      </div>
      <LoginFooter />
    </div>
  );
};

export default Unverified;
